<mat-form-field appearance="outline" [floatLabel]="'always'">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <mat-select
        #draggableMultiSelect
        [formControl]="aumFormControl"
        [placeholder]="placeholder"
        multiple
        (selectionChange)="getSelections($event)"
    >
        <div cdkDropList (cdkDropListDropped)="onDrop($event)">
            <span *ngFor="let option of selectionOptions" cdkDrag>
                <mat-option [value]="option"> {{option.name}} </mat-option>
            </span>
        </div>
    </mat-select>
    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-error *ngIf="aumFormControl && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
